import React from "react";
import {Checkbox} from "@mui/material";


const UncheckedIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="11" height="11" rx="0.857143" stroke="#A2A2A2" />
    </svg>
);

const CheckedIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="12" height="12" rx="0.857143" fill="#494949" />
        <path d="M3 6L5 8L9 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const IndeterminateIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="11" height="11" rx="0.857143" fill="white" stroke="#A2A2A2" />
        <rect x="3" y="3" width="6" height="6" fill="#494949" />
    </svg>
);

const CustomCheckbox = (props) => (
    <Checkbox
        {...props}
        icon={<UncheckedIcon />}
        checkedIcon={<CheckedIcon />}
        indeterminateIcon={<IndeterminateIcon />}
        sx={{
            width: 12,
            height: 12,
            padding: 0,
            marginLeft: 0,
            marginRight: "6px",
            verticalAlign: "middle",
        }}
    />
);

export default CustomCheckbox;
